
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpProgresschartComponent } from './cp-progresschart.component';

@NgModule({
  declarations: [CpProgresschartComponent],
  exports: [CpProgresschartComponent],
  imports: [CommonModule]
})
export class ProgressChartModule {}

